import { useContext } from "react";

import { GlobalContext } from "utils/context";

export const useGlobalContext = () => useContext(GlobalContext);
